module.exports = __webpack_public_path__ + "assets/img/admission-info-bannner.16cc2f25.png";